"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageMap = void 0;
const type_1 = require("../type");
exports.languageMap = {
    [type_1.Language.EN]: {
        names: {
            [type_1.Channel.SYSTEM]: 'More',
            [type_1.Channel.REDDIT]: 'Reddit',
            [type_1.Channel.FACEBOOK]: 'Facebook',
            [type_1.Channel.TELEGRAM]: 'Telegram',
            [type_1.Channel.XIAOHONGSHU]: 'REDnote',
            [type_1.Channel.TWITTER]: 'X',
            [type_1.Channel.INSTAGRAM]: 'Instagram',
            [type_1.Channel.WHATSAPP]: 'WhatsApp',
            [type_1.Channel.WXFRIEND]: 'WeChat',
            [type_1.Channel.WXTIMELINE]: 'WeChat Moments',
            [type_1.Channel.COPY]: 'Copy Link'
        },
        copySuccess: 'Copied',
        requestFail: 'Request Failed',
        appNotInstalled: 'Sharing failed: The required app not installed'
    },
    [type_1.Language.SC]: {
        names: {
            [type_1.Channel.SYSTEM]: '更多',
            [type_1.Channel.REDDIT]: 'Reddit',
            [type_1.Channel.FACEBOOK]: 'Facebook',
            [type_1.Channel.TELEGRAM]: 'Telegram',
            [type_1.Channel.XIAOHONGSHU]: '小红书',
            [type_1.Channel.TWITTER]: 'X',
            [type_1.Channel.INSTAGRAM]: 'Instagram',
            [type_1.Channel.WHATSAPP]: 'WhatsApp',
            [type_1.Channel.WXFRIEND]: '微信',
            [type_1.Channel.WXTIMELINE]: '朋友圈',
            [type_1.Channel.COPY]: '复制链接'
        },
        copySuccess: '复制成功',
        requestFail: '请求失败',
        appNotInstalled: '分享失败：请先安装所需应用'
    },
    [type_1.Language.TC]: {
        names: {
            [type_1.Channel.SYSTEM]: '更多',
            [type_1.Channel.REDDIT]: 'Reddit',
            [type_1.Channel.FACEBOOK]: 'Facebook',
            [type_1.Channel.TELEGRAM]: 'Telegram',
            [type_1.Channel.XIAOHONGSHU]: '小紅書',
            [type_1.Channel.TWITTER]: 'X',
            [type_1.Channel.INSTAGRAM]: 'Instagram',
            [type_1.Channel.WHATSAPP]: 'WhatsApp',
            [type_1.Channel.WXFRIEND]: 'WeChat',
            [type_1.Channel.WXTIMELINE]: '朋友圈',
            [type_1.Channel.COPY]: '複製連結'
        },
        copySuccess: '複製成功',
        requestFail: '請求失敗',
        appNotInstalled: '分享失敗：请先安裝所需應用'
    },
    [type_1.Language.JP]: {
        names: {
            [type_1.Channel.SYSTEM]: '…',
            [type_1.Channel.REDDIT]: 'Reddit',
            [type_1.Channel.FACEBOOK]: 'Facebook',
            [type_1.Channel.TELEGRAM]: 'Telegram',
            [type_1.Channel.XIAOHONGSHU]: 'REDnote',
            [type_1.Channel.TWITTER]: 'X',
            [type_1.Channel.INSTAGRAM]: 'Instagram',
            [type_1.Channel.WHATSAPP]: 'WhatsApp',
            [type_1.Channel.WXFRIEND]: 'WeChat',
            [type_1.Channel.WXTIMELINE]: 'コピーリンク',
            [type_1.Channel.COPY]: 'Copy Link'
        },
        copySuccess: 'コピー成功',
        requestFail: '操作エラー',
        appNotInstalled: 'Sharing failed: The required app not installed'
    }
};
//# sourceMappingURL=data:application/json;base64,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